import script from "./AddOrder.vue?vue&type=script&setup=true&lang=js"
export * from "./AddOrder.vue?vue&type=script&setup=true&lang=js"

import "./AddOrder.vue?vue&type=style&index=0&id=ebe081d0&scoped=true&lang=css"

import exportComponent from "/Users/amsrafid/Projects/www/miaccounts-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ebe081d0"]])

export default __exports__